import { Component, OnInit, ViewChild } from '@angular/core';
import { ClusterSiteBigCategoryData } from '../common/models/ClusterFactory';
import { ComparativeAnalyticsService } from './comparative-analytics.service';
import { FormGroup, FormControl } from '@angular/forms';
import { MatSelect, MatOption} from '@angular/material';
import { Role } from '../common/models/role';
import { DashboardSqlService } from '../dashboard-sql/dashboard-sql.service';
import { ExcelService } from '../dashboard-sql/excel.service';
import { AuthenticationService } from '../common/services/authentication.service';
import { CONSOLIDATECOMPARATIVEANALYSISCOLUMS, DEFECTSEVERITYSELECT, DPIDEFECTCLASSSELECT } from '../common/constants/labels';
import { ComparativeLostTreeYearOfYearViewModel } from '../common/models/qamatrix-analytics-filterparameter';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-comparative-analytics',
  templateUrl: './comparative-analytics.component.html',
  styleUrls: ['./comparative-analytics.component.scss']
})
export class ComparativeAnalyticsComponent implements OnInit {
  title = 'Comparative Analytics';
  comparativeAnalysisCol = CONSOLIDATECOMPARATIVEANALYSISCOLUMS;
  ValidationMsg = 'Please select From Date, To Date,Cluster, Site, Big Category.';
  showValidationMessage = false;
  clustersitebigcategoryArray: Array<ClusterSiteBigCategoryData> = [];
  cluster: string[] = [];
  site: string[] = [];
  bigcategory: string[] = [];
  clustertooltip = [];
  sitetooltip = [];
  bigcategorytooltip = [];
  qamatrixAnalyticsForm = new FormGroup({
    clusters: new FormControl(),
    sites: new FormControl(),
    bigcategories: new FormControl(),
    Year1Control: new FormControl(),
    Year2Control: new FormControl(),
    dpiDefectClassSelectControl: new FormControl(),
    defectSeveritySelectControl: new FormControl(),
  });

  qamatrixDefects = new FormGroup({
    clusterFilter: new FormControl(),
    siteFilter: new FormControl(),
    bigCategoryFilter: new FormControl(),
    userFilter: new FormControl()
  });

  clusterFiltertooltip = [];
  siteFiltertooltip = [];
  bigcategoryFiltertooltip = [];
  userFiltertooltip = [];

  role;
  @ViewChild('clusterControl', {static: false}) clusterControl: MatSelect;
  @ViewChild('siteControl', {static: false}) siteControl: MatSelect;
  @ViewChild('bigCategoryControl', {static: false}) bigCategoryControl: MatSelect;

  @ViewChild('clusterFilter', {static: false}) clusterFilterControl: MatSelect;
  @ViewChild('siteFilter', {static: false}) siteFiltercontrol: MatSelect;
  @ViewChild('bigCategoryFilter', {static: false}) bigCategoryFilterControl: MatSelect;
  @ViewChild('userFilter', {static: false}) userFilterControl: MatSelect;

  allSelected = false;
  siteAllSelected = false;
  bigCategoryAllSelected = false;
  clusterdefault = [];
  sitedefault = [];
  bigcategorydefault = [];
  showSuccess = false;
  filterParameter: any;
  filterParamForComparativeLostTree: any;
  dataAvailable = false;
  lossTreeDataSource = [];
  pivotTableDetails = [];
  nofiltereddata = false;
  clusterfilter: string[] = [];
  sitefilter: string[] = [];
  bigcategoryfilter: string[] = [];
  userfilter: string[] = [];
  clusterfilterdefault: string[] = [];
  sitefilterdefault: string[] = [];
  bigcategoryfilterdefault: string[] = [];
  userfilterdefault: string[] = [];
  bigCategoryFilterSelectedAll = false;
  userFilterSelectedAll = false;
  siteFilterSelectedAll = false;
  clusterFilterSelectedAll = false;
  disableCluster = false;
  disableSite = false;
  noRecords = 'No records';
  yearSelect = [];
  loading: boolean;
  comparativeAnalysisDataSource: any[];
  headerOccurancesH1Year2: string;
  headerDefectpriorityindexH1Year2: string;
  headerDefectpriorityindexH2Year2: string;
  headerOccurancesH2Year2: string;
  headerOccurancesY1: any;
  headerDefectpriorityindexY1: any;
  headerDefectpriorityindexY2: any;
  headerOccurancesY2: any;
  headerOccurancesH1Y1: string;
  headerOccurancesH1Y2: string;
  headerDefectpriorityindexH1Y1: string;
  headerDefectpriorityindexH1Y2: string;
  headerOccurancesH2Y1: string;
  headerOccurancesH2Y2: string;
  headerDefectpriorityindexH2Y1: string;
  headerDefectpriorityindexH2Y2: string;
  showgrid = false;
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  dataSource!: MatTableDataSource<any>;

  constructor(private dashboardService: DashboardSqlService, private analysisService: ComparativeAnalyticsService, private excelService: ExcelService, private authenticateService: AuthenticationService) { }

  ngOnInit() {
    this.loading = true;
    this.setYear();
    this.getClusterSiteBigCategoryData();
    this.nofiltereddata = true;
    this.noRecords = '';
  }

  setYear() {
    const currentYear = new Date().getFullYear();
    this.yearSelect = [];

    for (let i = currentYear; i <= currentYear; i--) {
      if (i < 2020) {
        break;
      }
      this.yearSelect.push(i);
    }
    this.qamatrixAnalyticsForm.controls['Year1Control'].setValue(this.yearSelect[1]);
    this.qamatrixAnalyticsForm.controls['Year2Control'].setValue(this.yearSelect[0]);
  }

  commonfunctionSetDefault(tempArray: string[], bigArray: string[]) {
    this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    this.sitedefault = this.sitedefault.length > 0 ? this.sitedefault : this.site;
    this.bigcategory = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    this.bigcategorydefault = this.bigcategorydefault.length > 0 ? this.bigcategorydefault : this.bigcategory;
    this.clustertooltip = this.clusterdefault.length > 0 ? this.clusterdefault : this.cluster;
    this.sitetooltip = this.sitedefault.length > 0 ? this.sitedefault : this.site;
    this.bigcategorytooltip = this.bigcategorydefault.length > 0 ? this.bigcategorydefault : this.bigcategory;
    if (this.cluster.length <= this.clusterdefault.length) {
      this.allSelected = true;
    }
    let siteAll = false;
    if (this.site.length <= this.sitedefault.length) {
      siteAll = true;
      this.siteControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          siteAll = false;
        }
      });
      this.siteAllSelected = siteAll;
    }

    let bigCategoryAll = false;
    if (this.bigcategory.length <= this.bigcategorydefault.length) {
      bigCategoryAll = true;
      this.bigCategoryControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          bigCategoryAll = false;
        }
      });
      this.bigCategoryAllSelected = bigCategoryAll;
    }

    if (this.role === Role.qualityChampion) {
      this.disableSite = false;
      this.disableCluster = true;
    } else if (this.role === Role.globalAdmin || this.role === Role.qualityGlobalRead) {
      this.disableSite = false;
      this.disableCluster = false;
    } else {
      this.disableSite = true;
      this.disableCluster = true;
    }
  }

  selectClusterSiteDropdownwithdefault() {
    this.loading = true;
    let factory = '';
    factory = localStorage.getItem('factory');
    const tempArray: string[] = [];
    const bigArray: string[] = [];
    const clustertemp: string[] = [];
    const sitetemp: string[] = [];
    const bigcategorytemp: string[] = [];
    for (let i = 0; i < this.clustersitebigcategoryArray.length; i++) {
      const factoryname = this.clustersitebigcategoryArray[i].factoryname;
      const site  = this.clustersitebigcategoryArray[i].site;
      const bigcategory = this.clustersitebigcategoryArray[i].businessgroup;
      const clustername = this.clustersitebigcategoryArray[i].subregion;
      if (factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, site)) {
        if (clustertemp.indexOf(clustername) === -1) {
          clustertemp.push(clustername);
        }
        if (sitetemp.indexOf(site) === -1) {
          sitetemp.push(site);
        }
        if (bigcategorytemp.indexOf(bigcategory) === -1) {
          bigcategorytemp.push(bigcategory);
        }
        this.clustersitebigcategoryArray.forEach(element => {
          if (clustername === element.subregion) {
            tempArray.push(element.site);
            // bigArray.push(element.bigcategory);
          }
        });
        this.clustersitebigcategoryArray.forEach(element => {
          if (site === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        break;
      }
    }
    /* this.clustersitebigcategoryArray.forEach(clusterfilter => {
      if (clusterfilter.factoryname === factory  || this.authenticateService.findSiteNameInFactoryName(factory, clusterfilter.site)) {
        if (clustertemp.indexOf(clusterfilter.clustername) === -1) {
          clustertemp.push(clusterfilter.clustername);
        }
        if (sitetemp.indexOf(clusterfilter.site) === -1) {
          sitetemp.push(clusterfilter.site);
        }
        if (bigcategorytemp.indexOf(clusterfilter.bigcategory) === -1) {
          bigcategorytemp.push(clusterfilter.bigcategory);
        }
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.clustername === element.clustername) {
            tempArray.push(element.site);
            // bigArray.push(element.bigcategory);
          }
        });
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.site === element.site) {
            bigArray.push(element.bigcategory);
          }
        });
      }
    }); */
    this.clusterdefault = clustertemp;
    this.sitedefault = sitetemp;
    this.bigcategory = bigcategorytemp;
    if (this.clusterdefault.length === 0) {
      const clusterdata = [];
      this.loading = true;
      this.role = localStorage.getItem('role');
      const clusterBasedOnRole = localStorage.getItem('clusterBasedOnRole');
      let clusterBasedOnRoleparsed = [];
      if (clusterBasedOnRole !== null && clusterBasedOnRole !== undefined) {
        clusterBasedOnRoleparsed = JSON.parse(clusterBasedOnRole);
        this.clusterdefault = clusterBasedOnRoleparsed;
        this.clustersitebigcategoryArray.forEach(element => {
          clusterBasedOnRoleparsed.forEach(x => {
            if (x === element.subregion) {
              tempArray.push(element.site);
              bigArray.push(element.businessgroup);
            }
          });
        });
        this.commonfunctionSetDefault(tempArray, bigArray);
        this.loading = false;
      } else {
        this.dashboardService.getClusterFromDFOS(this.role).subscribe((response) => {
          if (response !== null) {
            response.forEach(element => {
              clusterdata.push(element.name);
            });
            localStorage.setItem('clusterBasedOnRole', JSON.stringify(clusterdata));
            this.clusterdefault = clusterdata;
            this.clustersitebigcategoryArray.forEach(element => {
              clusterdata.forEach(x => {
                if (x === element.subregion) {
                  tempArray.push(element.site);
                  bigArray.push(element.businessgroup);
                }
              });
            });
            this.commonfunctionSetDefault(tempArray, bigArray);
          }
          this.loading = false;
        });
      }
    } else {
      this.commonfunctionSetDefault(tempArray, bigArray);
      this.loading = false;
    }
  }

  getClusterSiteBigCategoryData() {
    this.dashboardService.getClusterFactoryData().subscribe((response) => {
      if (response.length === 0) {
        this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try again after sometime.';
        this.showValidationMessage = true;
        this.loading = false;
      } else {
        // this.noRecordsShow = false;
        // const UpdatedResponse = [];
        response.forEach((e) => {
          let object: ClusterSiteBigCategoryData;
          object = {
            subregion: e.subregion,
            site: e.site,
            businessgroup: e.businessgroup,
            factoryname: e.factoryname
          };
          this.clustersitebigcategoryArray.push(object);
        });
        this.cluster = this.clustersitebigcategoryArray.map(item => item.subregion).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectClusterSiteDropdownwithdefault();
        this.loading = false;
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try again after sometime.';
      this.showValidationMessage = true;
      this.loading = false;
    });
  }

  loadSite() {
    this.loading = true;
    this.bigcategory = [];
    this.site = [];
    const tempArray: string[] = [];
    this.clustertooltip = [];
    this.sitetooltip = [];
    this.bigcategorytooltip = [];
    this.qamatrixAnalyticsForm.get('sites').setValue(null);
    let clusterSelected = [];
    if (this.qamatrixAnalyticsForm.get('clusters').value !== null && this.qamatrixAnalyticsForm.get('clusters').value.length > 0) {
      clusterSelected = this.qamatrixAnalyticsForm.get('clusters').value;
      this.clustertooltip = clusterSelected;
      let clusterAll = true;
      this.clusterControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          clusterAll = false;
        }
      });
      this.allSelected = clusterAll;
      clusterSelected.forEach(clusterelement => {
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterelement === element.subregion) {
            tempArray.push(element.site);
          }
        });
      });
      this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
      this.sitedefault = this.site;
      this.sitetooltip = this.sitedefault;
      setTimeout(() => {
        this.loadBigCategory();
      }, 2000);
    } else {
      this.loading = false;
    }
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  clearData() {
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  loadBigCategory() {
    this.bigcategory = [];
    this.qamatrixAnalyticsForm.get('bigcategories').setValue(null);
    this.sitetooltip = [];
    this.bigcategorytooltip = [];
    let siteSelected = [];
    const tempBigCategoryArray: string[] = [];
    if (this.qamatrixAnalyticsForm.get('sites').value !== null && this.qamatrixAnalyticsForm.get('sites').value.length > 0) {
      siteSelected = this.qamatrixAnalyticsForm.get('sites').value;
      this.sitetooltip = siteSelected;
      siteSelected.forEach(siteelement => {
        this.clustersitebigcategoryArray.forEach(element => {
          if (siteelement === element.site) {
            tempBigCategoryArray.push(element.businessgroup);
          }
        });
      });
      this.bigcategory = tempBigCategoryArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
      this.bigcategorydefault = this.bigcategory;
      this.bigcategorytooltip = this.bigcategorydefault;
      let siteAll = true;
      this.siteControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          siteAll = false;
        }
      });
      this.siteAllSelected = siteAll;

      let bigCategoryAll = true;
      this.bigCategoryControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          bigCategoryAll = false;
        }
      });
      this.bigCategoryAllSelected = bigCategoryAll;
      this.showValidationMessage = false;
      this.showSuccess = false;
      this.dataAvailable = false;
      this.noRecords = '';
      this.nofiltereddata = true;
      this.loading = false;
    }
  }

  // Authorization
  get isAuthorized() {
    this.role = localStorage.getItem('role');
    if (this.role === Role.globalAdmin) {
      return true;
    } else {
      return false;
    }
  }

  optionClick() {
    let newStatus = true;
    this.clusterControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }

  optionclusterFilterClick() {
    let newStatus = true;
    this.clusterFilterControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.clusterFilterSelectedAll = newStatus;
  }

  optionsiteFilterClick() {
    let newStatus = true;
    this.siteFiltercontrol.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.siteFilterSelectedAll = newStatus;
  }

  optionBigCategoryFilterClick() {
    let newStatus = true;
    this.bigCategoryFilterControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.bigCategoryFilterSelectedAll = newStatus;
  }

  optionUserFilterClick() {
    let newStatus = true;
    this.userFilterControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.userFilterSelectedAll = newStatus;
  }

  toggleSiteAllSelection() {
    if (this.siteAllSelected) {
      this.siteControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.siteControl.options.forEach((item: MatOption) => item.deselect());
      this.sitetooltip = [];
      this.bigcategorytooltip = [];
    }
  }

  optionsiteClick() {
    let newStatus = true;
    this.siteControl.options.forEach((item: MatOption) => {
    if (!item.selected) {
        newStatus = false;
      }
    });
    this.siteAllSelected = newStatus;
  }

  toggleBigCategoryAllSelection() {
   if (this.bigCategoryAllSelected) {
      this.bigCategoryControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.bigCategoryControl.options.forEach((item: MatOption) => item.deselect());
      this.bigcategorytooltip = [];
    }
  }

  optionBigCategoryClick() {
    let newStatus = true;
    this.bigCategoryControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.bigCategoryAllSelected = newStatus;
  }

  toggleAllSelection() {
    if (this.allSelected) {
      this.clusterControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.clusterControl.options.forEach((item: MatOption) => item.deselect());
      this.clustertooltip = [];
      this.sitetooltip = [];
      this.bigcategorytooltip = [];
    }
  }

  generateReport() {
    this.loading = true;
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.ValidationMsg = '';
    const year1 = this.qamatrixAnalyticsForm.controls['Year1Control'].value;
    const year2 = this.qamatrixAnalyticsForm.controls['Year2Control'].value;
    const selectedcluster = this.qamatrixAnalyticsForm.get('clusters').value;
    const selectedsite = this.qamatrixAnalyticsForm.get('sites').value;
    const selectedbigcategory = this.qamatrixAnalyticsForm.get('bigcategories').value;
    const dpiDefectsClass = DPIDEFECTCLASSSELECT;
    const defectSeverity = DEFECTSEVERITYSELECT;
    let isValidationSuccess = true;

    if (year1 > year2) {
      this.showValidationMessage = true;
      this.loading = false;
      this.ValidationMsg = 'Reference Year should be greater than the Target Year';
      isValidationSuccess = false;
    } else if (selectedcluster === null || selectedcluster === '' || selectedcluster.length === 0
    || selectedsite === null || selectedsite === '' || selectedsite.length === 0
    || selectedbigcategory === null || selectedbigcategory === '' || selectedbigcategory.length === 0) {
      this.showValidationMessage = true;
      this.loading = false;
      this.ValidationMsg = 'Please select Cluster, Site, Big Category.';
      isValidationSuccess = false;
    }
    if (this.ValidationMsg === null || this.ValidationMsg === '') {
      this.headerOccurancesH1Year2 = 'H1 - ' + year2;
      this.headerOccurancesH2Year2 = 'H2 - ' + year2;
      this.headerDefectpriorityindexH1Year2 = 'H1 - ' + year2;
      this.headerDefectpriorityindexH2Year2 = 'H2 - ' + year2;
      this.headerOccurancesY1 = year1;
      this.headerOccurancesY2 = year2;
      this.headerDefectpriorityindexY1 = year1;
      this.headerDefectpriorityindexY2 = year2;
      this.headerOccurancesH1Y1 = 'H1 - ' + year1;
      this.headerOccurancesH1Y2 = 'H1 - ' + year2;
      this.headerDefectpriorityindexH1Y1 = 'H1 - ' + year1;
      this.headerDefectpriorityindexH1Y2 = 'H1 - ' + year2;
      this.headerOccurancesH2Y1 = 'H2 - ' + year1;
      this.headerOccurancesH2Y2 = 'H2 - ' + year2;
      this.headerDefectpriorityindexH2Y1 = 'H2 - ' + year1;
      this.headerDefectpriorityindexH2Y2 = 'H2 - ' + year2;

      this.filterParamForComparativeLostTree = {
        ReferenceYear: year1,
        TargetYear: year2,
        BigCategory: selectedbigcategory,
        Cluster: selectedcluster,
        Site: selectedsite,
        DpiDefectClass: dpiDefectsClass,
        DefectSeverity: defectSeverity
      };
      this.getConsolidateComparativeAnalytics(this.filterParamForComparativeLostTree);
    }
  }

  getConsolidateComparativeAnalytics(filterParamForComparativeLostTree: ComparativeLostTreeYearOfYearViewModel) {
    this.analysisService.getComparativeAnalysisYearOfYearData(filterParamForComparativeLostTree).subscribe(response => {
      this.dataAvailable = true;
      if (response.defectModeAggregationDetails !== null && response.defectModeAggregationDetails.length > 1) {
        const defectModeAggregationDetails = [];
        response.defectModeAggregationDetails.forEach(e => {
          let object = {};
          object = {
            level0: e.leveL0,
            defectmodeaggregation: e.defectmodeaggregation,
            subregion: e.subregion,
            sites: e.sites,
            businessgroup: e.businessgroup,
            fourms: e.fourms,
            occurancesH1Year2: e.occurancesH1Year2,
            occurancesH2Year2: e.occurancesH2Year2,
            changeinoccurancesYear2: e.changeinoccurancesYear2,
            pdcastatusH1: e.pdcastatusH1,
            pdcastatusH2: e.pdcastatusH2,
            defectpriorityindexH1Year2: e.defectpriorityindexH1Year2,
            defectpriorityindexH2Year2: e.defectpriorityindexH2Year2,
            changeindpiYear2: e.changeindpiYear2,
            occurancesY1: e.occurancesY1,
            occurancesY2: e.occurancesY2,
            changeinoccurancesYoY: e.changeinoccurancesYoY,
            defectpriorityindexY1: e.defectpriorityindexY1,
            defectpriorityindexY2: e.defectpriorityindexY2,
            changeindpiYoY: e.changeindpiYoY,
            occurancesH1Y1: e.occurancesH1Y1,
            occurancesH1Y2: e.occurancesH1Y2,
            changeinoccurancesH1: e.changeinoccurancesH1,
            defectpriorityindexH1Y1: e.defectpriorityindexH1Y1,
            defectpriorityindexH1Y2: e.defectpriorityindexH1Y2,
            changeindpiH1: e.changeindpiH1,
            occurancesH2Y1: e.occurancesH2Y1,
            occurancesH2Y2: e.occurancesH2Y2,
            changeinoccurancesH2: e.changeinoccurancesH2,
            defectpriorityindexH2Y1: e.defectpriorityindexH2Y1,
            defectpriorityindexH2Y2: e.defectpriorityindexH2Y2,
            changeindpiH2: e.changeindpiH2
          };

          defectModeAggregationDetails.push(object);
        });
        this.comparativeAnalysisDataSource = defectModeAggregationDetails;
        this.dataSource = new MatTableDataSource(this.comparativeAnalysisDataSource);
        this.dataSource.paginator = this.paginator;
        this.loading = false;
        this.nofiltereddata = false;
        this.showgrid = true;
        // this.filterData();
      } else {
        this.loading = false;
        this.ValidationMsg = 'No data available.';
        this.showValidationMessage = true;
        this.dataAvailable = false;
        this.noRecords = '';
        this.nofiltereddata = true;
        this.showgrid = false;
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get report data. Please try again after sometime.';
      this.showValidationMessage = true;
      this.noRecords = '';
      this.nofiltereddata = true;
      this.showgrid = false;
      this.loading = false;
    });
  }

}
